import React from 'react';

import ImagesByRoom from '../../ImagesVideo/ImagesByRoom';
import type { PropertyRoomTypeWithImages } from '../../ImagesVideo/types';
import type { OfferBuilderMediaController } from '../../useOfferBuilderMedia';

interface Props {
  media: OfferBuilderMediaController;
  onOpenImagesVideo: () => void;
  propertyRoomTypes: Array<PropertyRoomTypeWithImages>;
  roomKey: string;
}

export default function ImagesTab({ media, onOpenImagesVideo, propertyRoomTypes, roomKey }: Props) {
  return (
    <ImagesByRoom
      excludedImagePublicIds={media.deletedImagePublicIds}
      hiddenImagePublicIds={media.hiddenImagePublicIds}
      isMetadataEditable
      mediaImages={media.mediaImages}
      onAssignImagesToRoom={media.assignImagesToRoom}
      onEditImage={media.editRoomImage}
      onOpenImagesVideo={onOpenImagesVideo}
      onRemoveImageFromRoom={media.removeImageFromRoom}
      onToggleHiddenImage={media.toggleHiddenImage}
      onUpdateImageTitle={media.updateImageTitle}
      propertyRoomTypes={propertyRoomTypes}
      showHeader={false}
      showRoomDetails={false}
      uploadedRoomAssignments={media.uploadedRoomAssignments}
      visibleRoomKeys={[roomKey]}
    />
  );
}
